import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ca007f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]

import { IonCol, IonText, IonRow } from "@ionic/vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'InfoEntry',
  props: {
    text: null,
    title: null,
    fontSizeTitle: null,
    fontSize: null,
    textColorBlue: null
  },
  setup(__props: any) {

const props = __props as {
    text: string;
    title: string;
    fontSizeTitle: string;
    fontSize: string;
    textColorBlue: {
        type: boolean;
        default: false;
    }
}





return (_ctx: any,_cache: any) => {
  return (__props.text)
    ? (_openBlock(), _createBlock(_unref(IonRow), { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCol), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonText), {
                        class: _normalizeClass(["info-titles", __props.fontSizeTitle])
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.title), 1)
                        ]),
                        _: 1
                      }, 8, ["class"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), null, {
                    default: _withCtx(() => [
                      (!__props.textColorBlue)
                        ? (_openBlock(), _createBlock(_unref(IonText), {
                            key: 0,
                            class: _normalizeClass(["info-texts", __props.fontSize])
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", { innerHTML: __props.text }, null, 8, _hoisted_1)
                            ]),
                            _: 1
                          }, 8, ["class"]))
                        : (_openBlock(), _createBlock(_unref(IonText), {
                            key: 1,
                            class: _normalizeClass(["info-texts-blue", __props.fontSize])
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", { innerHTML: __props.text }, null, 8, _hoisted_2)
                            ]),
                            _: 1
                          }, 8, ["class"]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})